import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const Italic = createSvgIcon(React.createElement("path", { d: "M10.666,2.5v2h1h1.498l-4.412,15H6.334h-1v2h1h6h1v-2h-1h-1.496l4.412-15h2.416h1v-2h-1\n\t    h-6H10.666z" }), 'Italic');
export default Italic;
